import { render, staticRenderFns } from "./article_search.vue?vue&type=template&id=baceb97e&scoped=true"
import script from "./article_search.vue?vue&type=script&lang=js"
export * from "./article_search.vue?vue&type=script&lang=js"
import style0 from "./article_search.vue?vue&type=style&index=0&id=baceb97e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baceb97e",
  null
  
)

export default component.exports